import React from "react";

import { AttachmentSVG, Button, Icon } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import PropTypes from "prop-types";

import { buttonCss, iconCss } from "./GraphicOrganizerModalButton.style";

const propTypes = {
  contentId: PropTypes.string,
  numberOfOrganizers: PropTypes.number,
  setActive: PropTypes.func,
  title: PropTypes.string.isRequired,
  triggerRef: PropTypes.any,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const GraphicOrganizerModalButton = ({
  contentId,
  numberOfOrganizers,
  setActive,
  title,
  triggerRef,
}) => {
  if (numberOfOrganizers === 0) return null;

  const eventProperties = {
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.interact,
    objectType: objectTypes.content,
    streamProperties: {
      description: `Open modal for ${title} graphic organizers`,
      content_id: contentId,
    },
  };

  return (
    <ButtonWithTrackEvent
      __cssFor={{ root: buttonCss }}
      dataProps={{
        "data-qa-selector": "formative-graphic-organizer-modal-open",
      }}
      flavor={Button.flavors.polarMuted}
      hasIcon
      iconAlignment="left"
      isFullWidth
      onClick={() => {
        setActive(true);
      }}
      ref={triggerRef}
      {...eventProperties}
    >
      <Icon
        __cssFor={{ root: iconCss }}
        SvgComponent={AttachmentSVG}
        size={Icon.sizes.sm}
      />
      {numberOfOrganizers} {title} graphic organizer
      {numberOfOrganizers > 1 ? "s" : ""}
    </ButtonWithTrackEvent>
  );
};

GraphicOrganizerModalButton.propTypes = propTypes;

export default GraphicOrganizerModalButton;
